export const INIT_APP = 'init_app';
export const SET_DEVICE_TYPE = 'set_device_type';
export const AUTH_FIELD_CHANGED = 'auth_field_changed';
export const REGISTER_USER = 'register_user';
export const REGISTER_USER_SUCCESS = 'register_user_success';
export const REGISTER_USER_FAIL = 'register_user_fail';
export const AUTH_UNLOAD = 'auth_unload';
export const TOGGLE_COPY = 'toggle_copy';

export const GET_TEAM_INFO = 'get_team_info';
export const GET_TEAM_INFO_FAIL = 'get_team_info_fail';
export const GET_TEAM_INFO_SUCCESS = 'get_team_info_success';

export const LOGIN_USER = 'login_user';
export const LOGIN_USER_FAIL = 'login_user_fail';
export const LOGIN_USER_SUCCESS = 'login_user_success';

export const PHONE_FIELD_CHANGE = 'phone_field_change';
//MODAL ACTIONS
export const TOGGLE_MODAL = 'toggle_modal';
export const START_MODAL_FADE = 'start_modal_fade';
export const SET_MODAL = 'set_modal';
export const SET_PLAN_MODAL = 'set_plan_modal';
export const TOGGLE_PLAN_MODAL = 'toggle_plan_modal';
export const SUCCESS_MESSAGE = 'success_message';
export const RESET_SUCCESS_MESSAGE = 'reset_success_message';

//WEB APP ONLLY
export const START_REDIRECT = 'start_redirect';
export const END_REDIRECT = 'end_redirect';
export const TEXT_LINK = 'text_link';
export const TEXT_LINK_SUCCESS = 'text_link_success';
export const TEXT_LINK_FAIL = 'text_link_fail';



// WEBPACK FOOTER //
// ./src/actions/types.js